import { CheckBoxItem } from './CheckBoxItem';
import { ButtonItem } from './ButtonItem';
import { UnderlineItem } from './UnderlineItem';
import type { DiFiCheckBoxProps } from './types';

export type { DiFiCheckBoxProps, DiFiCheckBoxType } from './types';

/**
 * 多选控件入口：`type` 仅负责分发到对应子组件
 * - checkbox → CheckBoxItem（方框勾选）
 * - button / segment → ButtonItem（按钮块）
 * - underline → UnderlineItem
 */
export const DiFiCheckBox = (props: DiFiCheckBoxProps) => {
  const t = props.type ?? 'checkbox';

  if (t === 'button' || t === 'segment') {
    return <ButtonItem itemProps={props} />;
  }
  if (t === 'underline') {
    return <UnderlineItem itemProps={props} />;
  }
  return <CheckBoxItem itemProps={props} />;
};
